module.exports = __webpack_public_path__ + "static/media/buy_start_service_rent_4.ad125123.jpg";